export const LAST_SELECTED_ORG_KEY = "LAST_SELECTED_ORG_SLUG";
